import axios from '@/store/interceptor';

import apiUrl from '../../config/api.config'

export async function getDepartments() {
    try {
        const response = await axios.get(`${apiUrl}/departments`);
        return response.data;
    } catch (error) {
        console.error("Error fetching departments:", error);
        throw error;
    }
}

export async function fetchBlocks() {
    try {
        const response = await axios.get(`${apiUrl}/locations`);
        return response.data;
    } catch (error) {
        console.error("Error fetching blocks:", error);
        throw error;
    }
}

export async function getFloorsByBlock(block) {
    try {
        const response = await axios.get(`${apiUrl}/locations/${block}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching floors:", error);
        throw error;
    }
}

export async function getRoomsByBlockAndFloor(block, floor) {
    try {
        const response = await axios.get(`${apiUrl}/locations/${block}/${floor}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching rooms:", error);
        throw error;
    }
}

export async function getLocationIdByDetails(selectedBlock, selectedFloor, selectedRoom) {
    try {
        const response = await axios.get(
            `${apiUrl}/locations/id?block=${selectedBlock}&floor=${selectedFloor}&room=${selectedRoom}`
        );
        return response.data;
    } catch (error) {
        console.error("Error fetching location id:", error);
        throw error;
    }
}

export async function getEquipments() {
    try {
        const response = await axios.get(`${apiUrl}/equipments`);
        return response.data;
    } catch (error) {
        console.error("Error fetching equipments:", error);
        throw error;
    }
}
export async function getEquipmentsTableData() {
    try {
        const response = await axios.get(`${apiUrl}/equipments/equipments-table-data`);
        return response.data;
    } catch (error) {
        console.error("Error fetching equipments:", error);
        throw error;
    }
}

export async function getEquipmentsTableDataByUser(personId) {
    try {
        const response = await axios.get(`${apiUrl}/equipments/${personId}/user-equipments-table-data`);
        return response.data;
    } catch (error) {
        console.error("Error fetching equipments:", error);
        throw error;
    }
}

export async function getResponsiblePersonData(equipmentId) {
    try {
        const response = await axios.get(`${apiUrl}/equipments/${equipmentId}/responsible-person`);
        return response.data;
    } catch (error) {
        console.error("Failed to fetch responsible person data:", error);
        throw error;
    }
}

export async function fetchEquipmentTypes() {
    try {
        const response = await axios.get(`${apiUrl}/equipment-types`);
        return response.data;
    } catch (error) {
        console.error("Error fetching equipment-types:", error);
        throw error;
    }
}

export async function getUsersDropDown() {
    try {
        const response = await axios.get(`${apiUrl}/users/user-dropdown`);
        return response.data;
    } catch (error) {
        console.error("Error fetching user-dropdown:", error);
        throw error;
    }
}

export async function saveEquipmentData(postData) {
    try {
        const response = await axios.post(`${apiUrl}/equipments`, postData, {
            headers: {
                "Content-Type": "application/json",
            },
        });

        return response.data;
    } catch (error) {
        console.error("Error saving equipment:", error);
        throw error;
    }
}

export async function updateEquipment(equipmentData) {
    try {
        const response = await axios.patch(`${apiUrl}/equipments/${equipmentData.id}`, equipmentData, {
            headers: {
                "Content-Type": "application/json",
            },
        });

        return response.data;
    } catch (error) {
        console.error("Error updating equipment:", error);
        throw error;
    }
}


export async function deleteEquipment(id) {
    try {
        const response = await axios.delete(`${apiUrl}/equipments/${id}`);
        return response.data;
    } catch (error) {
        console.error("Error deleting equipments:", error);
        throw error;
    }
}

export async function getEquipmentsByUser(userId) {
    try {
        const response = await axios.get(`${apiUrl}/equipments/by-user/${userId}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching equipment by user:", error);
        throw error;
    }
}

export async function transferEquipments(transferData) {
    try {
        const response = await axios.post(`${apiUrl}/equipments/transfer`, transferData);
        return response.data;
    } catch (error) {
        console.error("Error transferring equipments:", error);
        throw error;
    }
}

// Who changed what on an item (across its transfers) and every request filed on it
export async function getEquipmentHistory(id) {
    const response = await axios.get(`${apiUrl}/equipments/${id}/history`);
    return response.data;
}

// Model names to suggest for a type (catalog + models already in use); the model itself stays free text
export async function getModelSuggestions(equipmentTypeId) {
    const response = await axios.get(`${apiUrl}/peripherals/suggestions`, { params: { equipmentTypeId } });
    return response.data;
}

// ── Model catalog (kinds + models), per equipment type; without a type: every type ──

export async function getPeripheralKinds(equipmentTypeId) {
    const response = await axios.get(`${apiUrl}/peripherals/kinds`, { params: { equipmentTypeId } });
    return response.data;
}

// createPeripheralKind("Cablu", 8) or createPeripheralKind({ name, equipment_type_id })
export async function createPeripheralKind(name, equipmentTypeId) {
    const body = typeof name === "object" ? name : { name, equipment_type_id: equipmentTypeId };
    const response = await axios.post(`${apiUrl}/peripherals/kinds`, body);
    return response.data;
}

export async function updatePeripheralKind(id, name) {
    const response = await axios.patch(`${apiUrl}/peripherals/kinds/${id}`, { name });
    return response.data;
}

export async function deletePeripheralKind(id) {
    await axios.delete(`${apiUrl}/peripherals/kinds/${id}`);
}

// [{ id, kind_id, kindName, equipment_type_id, name, fullName }]
export async function getPeripheralModels(equipmentTypeId) {
    const response = await axios.get(`${apiUrl}/peripherals/models`, { params: { equipmentTypeId } });
    return response.data;
}

export async function createPeripheralModel(data) {
    const response = await axios.post(`${apiUrl}/peripherals/models`, data);
    return response.data;
}

export async function updatePeripheralModel(id, data) {
    const response = await axios.patch(`${apiUrl}/peripherals/models/${id}`, data);
    return response.data;
}

export async function deletePeripheralModel(id) {
    await axios.delete(`${apiUrl}/peripherals/models/${id}`);
}

// ── Item card (QR sticker) and comments ──

// The item behind a sticker: its current row + canView / canRequest / requestDepartment / canSeeLabel
export async function getItemByTag(tag) {
    const response = await axios.get(`${apiUrl}/equipments/by-tag/${encodeURIComponent(tag)}`);
    return response.data;
}

// One item with its relations (the edit dialog's shape is built from it)
export async function getEquipment(id) {
    const response = await axios.get(`${apiUrl}/equipments/${id}`);
    return response.data;
}

// { equipmentId, canInternal, seesInternal, comments: [{ id, text, is_internal, created_at, user, mine, files }] }
export async function getItemComments(equipmentId) {
    const response = await axios.get(`${apiUrl}/equipments/${equipmentId}/comments`);
    return response.data;
}

// { text, is_internal, file_ids } -> the saved comment
export async function addItemComment(equipmentId, data) {
    const response = await axios.post(`${apiUrl}/equipments/${equipmentId}/comments`, data);
    return response.data;
}

// The server's message for a refused seria (409 SERIAL_TAKEN, Wi-Fi code / link, too long), '' for other errors
export function serialErrorMessage(error) {
    const data = error && error.response && error.response.data;
    if (!data) return "";
    const message = Array.isArray(data.message) ? data.message.join(". ") : data.message || "";
    if (data.code === "SERIAL_TAKEN" || data.code === "SERIAL_INVALID") return message;
    if (error.response.status === 400 && /seria|wi-fi|link/i.test(message)) return message;
    return "";
}
